import { RuleString } from 'fastest-validator';
import decoratorFactory from '@/utils/validator/decorators/decoratorFactory';
import errorMessages from '@/utils/validator/error.messages';

export interface CustomStringRule extends RuleString {
  isKana?: boolean,
  isFullWidth?: boolean,
}

export const String = decoratorFactory<CustomStringRule>({ type: 'string' });

const jaRegex = /^[\u30A0-\u30FF]+$/;

function detectFullWidth(value: string): boolean {
  if (!value) return false;
  return [...value].some((char) => {
    const code = char.charCodeAt(0);
    return (code >= 0x2000 && code <= 0xff60) || code >= 0xffa0;
  });
}

export default {
  messages: {
    isKana: errorMessages.isKana,
    isFullWidth: errorMessages.isFullWidth,
  },
  default: {
    isKana: false,
    isFullWidth: false,
    custom(value: string, err: {type: string}[], schema: {isKana: boolean, isFullWidth: boolean}) {
      console.log(schema);
      if (schema.isKana && !jaRegex.test(value)) err.push({ type: 'isKana' });
      if (schema.isFullWidth && !detectFullWidth(value)) err.push({ type: 'isKana' });
      return value;
    },
  },
};
